import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-sec c-cnbc"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "c-sec__title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/logo-cnbc.png",
    width: "345",
    height: "60",
    alt: "日経CNBC"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "c-label" }, "定期更新")
], -1)
const _hoisted_3 = { class: "l-inner" }
const _hoisted_4 = { class: "p-cate-list" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "c-summary" }
const _hoisted_7 = { class: "c-item__feat" }
const _hoisted_8 = { class: "c-item__feat_main" }
const _hoisted_9 = { class: "c-item__update" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.listChannels().length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listChannels(), (channel) => {
              return (_openBlock(), _createElementBlock("div", {
                key: channel.id,
                class: "c-item"
              }, [
                _createVNode(_component_router_link, {
                  to: { path: `/nkcnbc/${channel.id}` }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("picture", null, [
                      _createElementVNode("img", {
                        src: channel.thumbnailPc,
                        alt: ""
                      }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(channel.title), 1)
                      ]),
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.formatAwsTimestamp(channel.latestTimestamp, false, true)) + " 更新", 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}